import { useGlobalClassname } from "../use-global-classname";

export function useSmoothScrolling(isActive: boolean) {
  return useGlobalClassname("smooth-scrolling", isActive);
}
